export enum enDashbord {
  LOCKANIMATION = 'LOCKANIMATION',
}
